module.exports = __webpack_public_path__ + "img/2.3c11d89d.png";